
<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>
  <nxt-json-view [data]="data.json" [levelOpen]="0"></nxt-json-view>
</div>
<div mat-dialog-actions class="p-4">
  <button class="pf-button filled sm blue" (click)="dialogRef.close()" cdkFocusInitial>Close</button>
</div>
